import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Client, CommandStatus, CommandTokenInfoDataOut, SequentalTokenDataOut } from '../../../../api/api-reference';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-sequential-token-load-information',
  standalone: true,
  imports: [CommonModule, TranslateModule, AngularSvgIconModule],
  templateUrl: './sequential-token-load-information.component.html',
  styleUrl: './sequential-token-load-information.component.scss'
})
export class SequentialTokenLoadInformationComponent implements OnInit {
  @Input() commandId?: string;
  @Output() close = new EventEmitter<void>();

  CommandStatus = CommandStatus;
  tokens: SequentalTokenDataOut[] = [];
  commandInfo: CommandTokenInfoDataOut | null = null;

  constructor(
    private client: Client,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    if (this.commandId) {
      this.client.getSequentialToken(this.commandId!).subscribe({
        next: (response) => {
          this.commandInfo = response;
          this.tokens = response.sequentialTokens ?? [];
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    }
  }

  //space infront of a Capital Letter
  statusColor(status: string | undefined): string {
    if (status === 'Success') return 'var(--green-button)';
    if (status === 'Failed') return 'var(--red-button)';
    if (status === 'Pending') return 'var(--pending)';
    return '';
  }

  formatTokenType(type: string): string {
    return type.replace(/([A-Z])/g, ' $1').trim();
  }

  toggleModal() {
    this.close.emit();
  }
}
